






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IPayment, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
const ns = { namespace: 'payment' };

@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'payment',
  }),
  mixins: [paginationMixin],
})
export default class PaymentList extends Vue {
  @Action('getEntities', ns) getEntities: () => void;
  @Getter('entitiesSlice', ns) entitiesSlice: IPayment[];
  @State('pageParams', ns) pageParams: IPageParams;
  headers = [{ text: 'Название', value: 'name' }];
  selected = [];
  interval = null;
  mounted() {
    this.getEntities();
  }
}
